<template>
  <div>
    <q-form @submit="this.onSubmit" class="form">
      <div class="form__item">
        <div class="info-field">
          <q-icon name="task_alt" size="20px" color="primary" class="field-icon" />
          <span class="info-label">Задача:</span>
          <span class="info-value">{{ this.data?.task_name || '-' }}</span>
        </div>
      </div>
      <div class="form__item">
        <div class="info-field">
          <q-icon name="event" size="20px" color="primary" class="field-icon" />
          <span class="info-label">Дата начала:</span>
          <span class="info-value">{{ formatDate(this.data?.plan_date || this.data?.labor_date) }}</span>
        </div>
      </div>
      <div class="form__item" v-if="!this.data?.work_task_plan_id && !this.data?.labor_plan_fact_id">
        <div class="date-field-with-icon">
          <q-icon name="event_available" size="20px" color="orange" class="field-icon" />
          <CustomDate
            label="Дата окончания"
            :value="this.formData.end_date"
            @change_date="(value) => onChange('end_date', value)"
            placeholder="Для массового заполнения"
            class="date-input"
            :minDate="this.data?.plan_date || this.data?.labor_date"
          />
        </div>
        <div class="hint-text">
          * Укажите для заполнения на диапазон дат
        </div>
      </div>
      <!-- Поля для "Выход людей" -->
      <template v-if="this.data?.is_labor">
        <div class="form__item">
          <CustomInput
            label="План (кол-во людей)"
            type="number"
            :value="this.formData.plan_people"
            @change_input="(value) => onChange('plan_people', value)"
            placeholder="Плановое количество"
            class="plan-input"
          />
        </div>
      </template>
      <!-- Обычное поле для задач -->
      <div v-else class="form__item">
        <CustomInput
          label="План"
          type="number"
          :value="this.formData.plan_value"
          @change_input="(value) => onChange('plan_value', value)"
          placeholder="Введите значение"
          class="plan-input"
        />
      </div>
      <div class="form-actions">
        <div v-if="(this.data?.work_task_plan_id || this.data?.labor_plan_fact_id)" class="delete-section">
          <q-btn
            label="Удалить"
            color="negative"
            outline
            :loading="this.loading"
            @click="onDelete"
            class="delete-btn"
          />
        </div>
        <CustomModalFooter :btn-loading="this.loading" />
      </div>
    </q-form>
  </div>
</template>

<script>
import CustomInput from "@/components/form/CustomInput";
import CustomDate from "@/components/form/CustomDate";
import CustomModalFooter from "@/components/modal/modals/modal-footer";

export default {
  name: "edit-tier-plan",
  components: { CustomInput, CustomDate, CustomModalFooter },
  props: ['data'],
  data() {
    return {
      loading: false,
      formData: {
        plan_value: this.data?.plan_value || '',
        plan_people: this.data?.plan_people || '',
        end_date: '', // Дата окончания для массового заполнения
      }
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
    },
    formatDate(date) {
      if (!date) return '-';
      // Преобразуем YYYY-MM-DD в DD.MM.YYYY
      const parts = date.split('-');
      if (parts.length === 3) {
        return `${parts[2]}.${parts[1]}.${parts[0]}`;
      }
      return date;
    },
    async onSubmit() {
      this.loading = true
      
      // Если это данные о людях (is_labor = true)
      if (this.data?.is_labor) {
        const submitData = {
          labor_plan_fact_id: this.data?.labor_plan_fact_id || null,
          work_group_id: this.data?.work_group_id,
          labor_date: this.data?.labor_date,
          plan_people: this.formData.plan_people || null,
          end_date: this.formData.end_date || null, // Дата окончания для массового заполнения
        }
        await this.data?.onSubmit(submitData)
      } else {
        // Передаем все необходимые данные включая task_dict_id из data
        // При создании (work_task_plan_id = null) все обязательные поля должны быть переданы
        const submitData = {
          plan_value: this.formData.plan_value || null,
          work_task_plan_id: this.data?.work_task_plan_id || null,
          work_group_id: this.data?.work_group_id,
          task_dict_id: this.data?.task_dict_id || null,
          work_group_level_id: this.data?.work_group_level_id || null,
          plan_date: this.data?.plan_date || null,
          end_date: this.formData.end_date || null, // Дата окончания для массового заполнения
        }
        await this.data?.onSubmit(submitData)
      }
      
      this.loading = false
    },
    async onDelete() {
      // Вызываем callback удаления - подтверждение будет в родительском компоненте
      this.loading = true
      
      // Если это данные о людях (is_labor = true)
      if (this.data?.is_labor) {
        const deleteData = {
          labor_plan_fact_id: this.data?.labor_plan_fact_id,
        }
        await this.data?.onDelete(deleteData)
      } else {
        const deleteData = {
          work_task_plan_id: this.data?.work_task_plan_id,
        }
        await this.data?.onDelete(deleteData)
      }
      
      this.loading = false
    },
  },
}
</script>

<style scoped lang="scss">
.form {
  display: flex;
  flex-direction: column;
  width: 320px;
  gap: 8px;
  margin-top: 5px;

  @media (max-width: 428px) {
    width: 100%;
  }
}

.form__item {
  margin-bottom: 0;
}

.info-field {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
  font-size: 13px;
  
  .field-icon {
    flex-shrink: 0;
  }
  
  .info-label {
    font-weight: 600;
    min-width: 90px;
    color: #666;
  }
  
  .info-value {
    color: #333;
    font-size: 13px;
  }
}

.date-field-with-icon {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  
  .field-icon {
    flex-shrink: 0;
    margin-top: 12px;
  }
  
  .date-input {
    flex: 1;
  }
}

.hint-text {
  font-size: 11px;
  color: #666;
  margin-top: 2px;
  margin-left: 28px;
  font-style: italic;
}

.plan-input {
  width: 100%;
  
  :deep(input) {
    text-align: center;
  }
}

.form-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 4px;
}

.delete-section {
  display: flex;
  justify-content: flex-start;
  padding-top: 6px;
  border-top: 1px solid #e0e0e0;
}

.delete-btn {
  min-width: 100px;
}
</style>

